import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"
import { ProductFamily } from "@custom-types/products"
import { GraphDto } from "@custom-types/graphs"

export type RoleHint = "whatif" | "build" | "None"

export const baseGraphFamiliesApi = createApi({
  reducerPath: "baseGraphFamiliesApi",
  baseQuery: authQuery,
  tagTypes: ["BaseGraphFamilies"],
  endpoints: (builder) => ({
    getProductFamilies: builder.query<
      ProductFamily[],
      { organisationKey: string; divisionKey: string; productKey: string; roleHint?: RoleHint }
    >({
      query: ({ organisationKey, divisionKey, productKey, roleHint }) => ({
        url: `/family/product/${productKey}--${organisationKey}--${divisionKey}?role_hint=${roleHint}`,
      }),
    }),
    getFamilyBases: builder.query<GraphDto[], { familyKey: string; roleHint?: RoleHint }>({
      query: ({ familyKey, roleHint }) => ({
        url: `/family/${encodeURIComponent(familyKey)}/bases?role_hint=${roleHint}`,
      }),
      providesTags: (_result, _error, arg) => [
        { type: "BaseGraphFamilies", id: `${arg.familyKey}-${arg.roleHint}` },
        "BaseGraphFamilies",
      ],
    }),
  }),
})

export const {
  useGetProductFamiliesQuery,
  useLazyGetProductFamiliesQuery,
  useLazyGetFamilyBasesQuery,
  useGetFamilyBasesQuery,
} = baseGraphFamiliesApi
